/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
export function deepCopy (obj, cache = []) {
  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  // if obj is hit, it is in circular structure
  const hit = cache.find(c => c.original === obj)
  if (hit) {
    return hit.copy
  }

  const copy = Array.isArray(obj) ? [] : {}
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy
  })

  Object.entries(obj).forEach(([key, value]) => { copy[key] = deepCopy(value, cache); })

  return copy
}

/*
 * Transforms an array of objects into an object of objects with the
 * object.id as key.
 *
 * >>> arrayToObjects([{id: 1, name: 'hello'}, {id: 2, name: 'hi'}])
 * {
 *     1: {id: 1, name: "hello"},
 *     2: {id: 2, name: "hi"},
 * }
 */
export const arrayToObjects = (array) =>
  (array || []).reduce((obj, item) => {
    obj[item.id] = item;
    return obj;
  }, {})
